// extracted by mini-css-extract-plugin
export default {"container":"comment-redirect_container__3w7+r"};